"use client";
import React, { useState } from "react";
import CommonTitle from "@/components/common/CommonTitle";
import { LoginHubspotButtonUrl } from "@/utils/hubspot-contants";
import CustomButton from "@/components/common/CustomButton";

const ComparePlans = () => {
  const [isTableExpanded, setIsTableExpanded] = useState(true);

  const toggleTable = () => {
    setIsTableExpanded(!isTableExpanded);
  };
  const planCtas = [
    { label: "Free Forever" },
    { label: "Start 14-day free trial" },
    { label: "Talk to Sales" },
    { label: "Contact Sales" },
  ];

  const plans = [
    {
      category: "WORKSPACES",
      features: [
        {
          name: "#of Workspaces",
          values: ["1", "5", "Unlimited", "Unlimited"],
        },
        { name: "Manage workspaces", values: [true, true, true, true] },
        { name: "Custom views", values: [true, true, true, true] },
      ],
    },
    {
      category: "Projects",
      features: [
        { name: "#of Projects", values: ["5", "50", "Unlimited", "Unlimited"] },
        { name: "Manage projects", values: [true, true, true, true] },
        { name: "Custom views", values: [true, true, true, true] },
        { name: "Make public or private", values: [true, true, true, true] },
        { name: "Archive projects", values: [true, true, true, true] },
        { name: "Project portfolios", values: [false, false, true, true] },
      ],
    },
    {
      category: "Tasks",
      features: [
        {
          name: "#of Tasks",
          values: ["Unlimited", "Unlimited", "Unlimited", "Unlimited"],
        },
        { name: "Manage tasks", values: [true, true, true, true] },
        { name: "Custom views", values: [true, true, true, true] },
        { name: "Subtasks", values: [true, true, true, true] },
        { name: "Multiple assignees", values: [true, true, true, true] },
        { name: "Task checklist", values: [true, true, true, true] },
        { name: "Task dependencies", values: [true, true, true, true] },
        { name: "Tags", values: [true, true, true, true] },
        { name: "Task comments", values: [true, true, true, true] },
        { name: "Bulk actions", values: [true, true, true, true] },
        { name: "Custom fields", values: [true, true, true, true] },
        { name: "Advanced workflows", values: [true, true, true, true] },
      ],
    },
    {
      category: "Goals",
      features: [
        { name: "#of Goals", values: ["5", "20", "Unlimited", "Unlimited"] },
        { name: "Manage goals", values: [true, true, true, true] },
        { name: "Custom views", values: [true, true, true, true] },
        { name: "Sub goals", values: [true, true, true, true] },
        { name: "Custom fields", values: [true, true, true, true] },
      ],
    },
    {
      category: "Docs",
      features: [
        { name: "#of Docs", values: ["10", "100", "Unlimited", "Unlimited"] },
        {
          name: "Manage docs (View, Edit, Comments)",
          values: [true, true, true, true],
        },
        { name: "Sub docs / Embeds", values: [true, true, true, true] },
        { name: "Doc sharing", values: [true, true, true, true] },
        { name: "Doc tags", values: [true, true, true, true] },
        { name: "Archive docs", values: [true, true, true, true] },
        { name: "Import and export docs", values: [true, true, true, true] },
        { name: "AI writing", values: [false, false, true, true] },
        { name: "Docs templates", values: [false, false, true, true] },
      ],
    },
    {
      category: "Teams",
      features: [
        { name: "#of Teams", values: ["5", "20", "Unlimited", "Unlimited"] },
        { name: "Team tags", values: [true, true, true, true] },
        { name: "Manage teams", values: [true, true, true, true] },
        { name: "Manage guests", values: [true, true, true, true] },
        { name: "Archive team", values: [true, true, true, true] },
      ],
    },
    {
      category: "Chat",
      features: [
        { name: "#of Channels", values: ["5", "20", "Unlimited", "Unlimited"] },
        { name: "Channel tags", values: [true, true, true, true] },
        { name: "Manage Channels", values: [true, true, true, true] },
        { name: "Direct messages", values: [true, true, true, true] },
        { name: "Make public or private", values: [true, true, true, true] },
        { name: "Archive Channel", values: [true, true, true, true] },
      ],
    },
    {
      category: "Security",
      features: [
        { name: "SOC2 Compliance", values: [true, true, true, true] },
        { name: "GDPR Compliance", values: [false, false, false, true] },
        {
          name: "Single Sign-on (Google, Microsoft, Okta)",
          values: [false, false, true, true],
        },
        {
          name: "Custom role & permissions",
          values: [false, false, false, true],
        },
        {
          name: "Custom SAML Provisioning",
          values: [false, false, false, true],
        },
      ],
    },
    {
      category: "Support",
      features: [
        { name: "Service support", values: [true, true, true, true] },
        {
          name: "Dedicated customer success manager",
          values: [false, false, false, true],
        },
      ],
    },
  ];

  const tableHeaderStyle = `w-[20%] text-[16px] py-3 min-w-[200px] xl:min-w-fit`;

  // horizontal section dividers
  const tableSectionDivider = `text-[14px] py-3 pl-6`;

  //   table feature name column styles
  const tableFirstDataStyle = `pl-6 text-[14px] leading-5 text-[#202020] w-[20%] min-w-[200px] xl:min-w-fit`;

  //   table common data cell styles
  const tableDataStyle = `py-3 text-base text-[14px] text-[#202020] text-center w-[20%] min-w-[200px] xl:min-w-fit`;

  return (
    <section className="py-[60px] xl:py-[120px]">
      <div className="container">
        <div className="mb-8 flex items-center justify-center">
          <div className="relative rounded-[8px]">
            <div
              onClick={toggleTable}
              className="h-full cursor-pointer overflow-hidden rounded-[8px] bg-[#EDFCFF] px-8 py-2 lg:px-8 lg:py-4"
            >
              <div className="flex items-center justify-center gap-4">
                <CommonTitle
                  color="#202020"
                  fontSizeClass="text-[20px] md:text-[26px] xl:text-[28px]"
                  fontWeightClass="font-medium"
                >
                  Compare all features
                </CommonTitle>
                <div
                  className={`transform transition-transform duration-300 ${isTableExpanded ? "rotate-180" : ""}`}
                >
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 18 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9 9L16 2"
                      stroke="#202126"
                      strokeWidth="4"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isTableExpanded && (
          <>
            <div
              className="compare_plan_table_wrapper compare_plan_table_header_wrapper sticky top-[70px] w-full max-w-full overflow-x-auto xl:top-[71px]"
              onScroll={(e) => {
                const body = document.querySelector(
                  ".compare_plan_table_body_wrapper",
                );
                if (body && body.scrollLeft !== e.currentTarget.scrollLeft)
                  body.scrollLeft = e.currentTarget.scrollLeft;
              }}
            >
              <table className="w-full min-w-[800px] table-fixed border-collapse">
                <thead className="bg-white">
                  <tr>
                    <th className={tableHeaderStyle + " " + " pl-6 text-left"}>
                      {" "}
                    </th>
                    <th
                      className={
                        tableHeaderStyle + " " + "text-center align-top"
                      }
                    >
                      <div className="flex flex-col items-center gap-2 py-1">
                        <span className="font-semibold">Starter</span>
                        <CustomButton
                          text={planCtas[0].label}
                          url={LoginHubspotButtonUrl}
                          variant="primary"
                          version="black"
                        />
                      </div>
                    </th>
                    <th
                      className={
                        tableHeaderStyle + " " + "text-center align-top"
                      }
                    >
                      <div className="flex flex-col items-center gap-2 py-1">
                        <span className="font-semibold">Plus</span>
                        <CustomButton
                          text={planCtas[1].label}
                          url={LoginHubspotButtonUrl}
                          variant="primary"
                          version="black"
                        />
                      </div>
                    </th>
                    <th
                      className={
                        tableHeaderStyle + " " + "text-center align-top"
                      }
                    >
                      <div className="flex flex-col items-center gap-2 py-1">
                        <span className="font-semibold">Business</span>
                        <CustomButton
                          text={planCtas[2].label}
                          url={LoginHubspotButtonUrl}
                          variant="primary"
                          version="black"
                        />
                      </div>
                    </th>
                    <th
                      className={
                        tableHeaderStyle + " " + "text-center align-top"
                      }
                    >
                      <div className="flex flex-col items-center gap-2 py-1">
                        <span className="font-semibold">Enterprise</span>
                        <CustomButton
                          text={planCtas[3].label}
                          url={LoginHubspotButtonUrl}
                          variant="primary"
                          version="black"
                        />
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div
              className="compare_plan_table_wrapper compare_plan_table_body_wrapper w-full max-w-full overflow-x-auto"
              onScroll={(e) => {
                const header = document.querySelector(
                  ".compare_plan_table_header_wrapper",
                );
                if (header && header.scrollLeft !== e.currentTarget.scrollLeft)
                  header.scrollLeft = e.currentTarget.scrollLeft;
              }}
            >
              <table className="w-full min-w-[800px] table-fixed">
                <tbody>
                  {plans.map((plan, index) => (
                    <React.Fragment key={index}>
                      {plan.category ? (
                        <tr>
                          <td className={tableSectionDivider} colSpan={5}>
                            <strong className="uppercase">
                              {plan.category}
                            </strong>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                      {plan.features.map((feature, idx) => (
                        <tr className="border-b border-[#E8E8E8]" key={idx}>
                          <td className={tableFirstDataStyle}>
                            {feature.name}
                          </td>
                          {feature.values.map((value, i) => (
                            <td className={tableDataStyle} key={i}>
                              {typeof value === "boolean" ? (
                                value ? (
                                  <div className="flex items-center justify-center">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        fill="#22c55e"
                                      />
                                    </svg>
                                  </div>
                                ) : (
                                  <div className="flex items-center justify-center">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        fill="#ef4444"
                                      />
                                    </svg>
                                  </div>
                                )
                              ) : (
                                <span className="text-[14px]">{value}</span>
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default ComparePlans;
